import { Hero } from './components/Hero';
import { Conceito } from './components/Conceito';
import { Curiosidade } from './components/Curiosidade';
import { QuemSomos } from './components/QuemSomos';
import { OQueFazemos } from './components/OQueFazemos';
import { ProjetosRealizados } from './components/ProjetosRealizados';
import { NossosVideos } from './components/NossosVideos';
import { Impacto } from './components/Impacto';
import { Parceria } from './components/Parceria';
import { Contato } from './components/Contato';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="bg-dark text-white">
      <Navbar />
      <Hero />
      <Conceito />
      <Curiosidade />
      <QuemSomos />
      <OQueFazemos />
      <ProjetosRealizados />
      <NossosVideos />
      <Impacto />
      <Parceria />
      <Contato />
      <Footer />
    </div>
  );
}
